<script module lang="ts">
</script>

<script lang="ts">
    import Markdown from "./Markdown.svelte"

    let {
        content,
    }: {
        content: {
            text: string
            skewedquotetoggle: boolean
            skewedquote: string
        }
    } = $props()
</script>

<div class="text">
    <div class:hasQuote={!!content.skewedquotetoggle}>
        <Markdown text={content.text} />
        {#if content.skewedquote}
            <div class="quote">
                <span class="upper-quotes">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M8 21C8.53043 21 9.03914 20.7893 9.41421 20.4142C9.78929 20.0391 10 19.5304 10 19L10 13C10 12.4696 9.78929 11.9609 9.41421 11.5858C9.03914 11.2107 8.53043 11 8 11C7.73478 11 7.48043 10.8946 7.29289 10.7071C7.10536 10.5196 7 10.2652 7 10L7 9C7 8.46957 7.21071 7.96086 7.58579 7.58579C7.96086 7.21072 8.46957 7 9 7C9.26522 7 9.51957 6.89464 9.70711 6.70711C9.89464 6.51957 10 6.26522 10 6L10 4C10 3.73478 9.89464 3.48043 9.70711 3.29289C9.51957 3.10536 9.26521 3 9 3C7.4087 3 5.88258 3.63214 4.75736 4.75736C3.63214 5.88258 3 7.4087 3 9L3 19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21L8 21ZM19 21C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19L21 13C21 12.4696 20.7893 11.9609 20.4142 11.5858C20.0391 11.2107 19.5304 11 19 11C18.7348 11 18.4804 10.8946 18.2929 10.7071C18.1054 10.5196 18 10.2652 18 10L18 9C18 8.46957 18.2107 7.96086 18.5858 7.58579C18.9609 7.21071 19.4696 7 20 7C20.2652 7 20.5196 6.89464 20.7071 6.70711C20.8946 6.51957 21 6.26522 21 6L21 4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3C18.4087 3 16.8826 3.63214 15.7574 4.75736C14.6321 5.88258 14 7.4087 14 9L14 19C14 19.5304 14.2107 20.0391 14.5858 20.4142C14.9609 20.7893 15.4696 21 16 21L19 21Z"
                            stroke="#242220"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                    </svg>
                </span>
                <em>
                    <Markdown text={content.skewedquote.replace(/\n/g, "<br/>")} />
                </em>
                <span class="lower-quotes"
                    ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M16 21C15.4696 21 14.9609 20.7893 14.5858 20.4142C14.2107 20.0391 14 19.5304 14 19L14 13C14 12.4696 14.2107 11.9609 14.5858 11.5858C14.9609 11.2107 15.4696 11 16 11C16.2652 11 16.5196 10.8946 16.7071 10.7071C16.8946 10.5196 17 10.2652 17 10L17 9C17 8.46957 16.7893 7.96086 16.4142 7.58579C16.0391 7.21072 15.5304 7 15 7C14.7348 7 14.4804 6.89464 14.2929 6.70711C14.1054 6.51957 14 6.26522 14 6L14 4C14 3.73478 14.1054 3.48043 14.2929 3.29289C14.4804 3.10536 14.7348 3 15 3C16.5913 3 18.1174 3.63214 19.2426 4.75736C20.3679 5.88258 21 7.4087 21 9L21 19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21L16 21ZM5 21C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19L3 13C3 12.4696 3.21071 11.9609 3.58579 11.5858C3.96086 11.2107 4.46957 11 5 11C5.26522 11 5.51957 10.8946 5.70711 10.7071C5.89464 10.5196 6 10.2652 6 10L6 9C6 8.46957 5.78929 7.96086 5.41421 7.58579C5.03914 7.21071 4.53043 7 4 7C3.73478 7 3.48043 6.89464 3.29289 6.70711C3.10536 6.51957 3 6.26522 3 6L3 4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73479 3 4 3C5.5913 3 7.11742 3.63214 8.24264 4.75736C9.36786 5.88258 10 7.4087 10 9L10 19C10 19.5304 9.78929 20.0391 9.41421 20.4142C9.03914 20.7893 8.53043 21 8 21L5 21Z"
                            stroke="#242220"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                    </svg></span
                >
            </div>
        {/if}
    </div>
</div>

<style lang="less" global>
    @import "../../../css/variables.less";
    div.text {
        display: flex;
        flex-direction: column;
        gap: 2.4rem;
        position: relative;
        width: 100%;
        & > div {
            display: flex;
            gap: 2.4rem;
            & > &.hasQuote {
                section {
                    max-width: 560px;
                    margin-right: 274px;
                    width: 100%;
                }
                .quote {
                    max-width: 408px;
                    position: absolute;
                    em {
                        font-weight: 700;

                        font-style: normal;
                    }
                    width: 100%;
                    padding: 0.9rem 2.4rem;
                    height: fit-content;
                    border-top: 1px solid var(--stroke-100);
                    border-bottom: 1px solid var(--stroke-100);

                    right: 0px;
                    transform: translateX(calc(30% + 2.4rem));
                    span {
                        position: absolute;

                        &.upper-quotes {
                            top: 0.9rem;
                            left: 0;
                        }
                        &.lower-quotes {
                            bottom: 0.9rem;
                            right: 0px;
                        }
                    }
                }
            }
            @media @max-mobile {
                flex-direction: column;
                &.hasQuote {
                    .quote {
                        max-width: 100%;
                    }
                }
            }
        }
    }
</style>
